import React from 'react';
import { Button, Modal, Row } from 'react-bootstrap-5';

import { callListUrl, CALL_LISTS_SHOW } from '../../../helpers/prospect_api';
import type { CallListImportStatus } from 'bundles/connect/types';

type Props = {
  callListData: CallListImportStatus;
  callListId: number;
  handleClose: () => void;
  setShowAddressModal: (show: boolean) => void;
}

export default function ImportModalErrors({
  callListData,
  callListId,
  handleClose,
  setShowAddressModal,
}: Props) {
  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <Modal.Title as="h5">Upload Complete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <p>Your properties have been processed and are ready to be viewed.</p>
        </Row>
        <div className="bg-light rounded d-flex align-items-center p-2 mb-2">
          <h6 className="m-0">{callListData.numFound}</h6>
          <p className="text-muted ps-2 m-0">Properties Found</p>
        </div>
        <div className="bg-light rounded d-flex align-items-center justify-content-between p-2">
          <div className="d-flex">
            <h6 className="m-0">{callListData.noPropertyAddresses.length}</h6>
            <p className="text-muted ps-2 m-0">Not Found</p>
          </div>
          <button
            className="btn btn-text-primary"
            onClick={() => setShowAddressModal(true)}
          >
            View Addresses
          </button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="text-primary" onClick={handleClose}>
          Close
        </Button>
        <Button href={callListUrl(CALL_LISTS_SHOW, callListId)} variant="secondary">
          View List
        </Button>
      </Modal.Footer>
    </>
  );
}
